module.exports = __webpack_public_path__ + "img/stock7.9a45dce1.png";